<template>
  <validation-observer v-slot="{ handleSubmit }" class="demo-data marketing-materials-subsection">
    <div class="columns" style="position:relative;">
      <div class="column is-7">
        <b-field>
          <span class="settings-text--gray">Demo data</span>
        </b-field>

        <form @submit.prevent="handleSubmit(applyDemoData)">
          <validation-provider v-slot="{ errors }" rules="required|json">
            <b-field
              v-model="form.demoData"
              :type="{ 'is-danger': errors.length }"
              :message="errors + [ '&nbsp;' ]"
            >
              <b-input
                v-model="form.demoData"
                :disabled="!checkAccess(MARKETING_MATERIALS_MANAGE_MODIFY)"
                type="textarea"
                rows="5"
              />
            </b-field>
          </validation-provider>
        </form>
      </div>

      <div class="column demo-data-buttons">
        <div class="buttons is-pulled-right">
          <b-button
            @click="onCancelClick"
            class="modern-button is-outlined"
          >
            cancel
          </b-button>

          <template v-if="checkAccess(MARKETING_MATERIALS_MANAGE_MODIFY)">
            <b-button
              class="modern-button"
              @click="handleSubmit(applyDemoData)"
            >
              submit
            </b-button>
          </template>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex';
import * as MUTATIONS from '@/store/mutations';
import {
  getFlyerTemplateSetting, updateFlyerTemplateSetting,
} from '@/api/settings';
import {
  MARKETING_MATERIALS_MANAGE_MODIFY,
} from '@/const/privileges';
import { get } from 'lodash';

export default {
  name: 'DemoData',

  data() {
    return {
      MARKETING_MATERIALS_MANAGE_MODIFY,
      setting: null,
      form: {
        demoData: '',
      },
    };
  },

  computed: {
    ...mapGetters(['hasAccess']),
  },

  async mounted() {
    this.startLoading();

    try {
      const response = await getFlyerTemplateSetting();
      if (
        response.data.total === 1
        && 'userId' in response.data.data[0]
        && response.data.data[0].userId != null
      ) {
        const setting = response.data.data[0];
        const params = setting.paramVal;
        if (params) {
          const obj = JSON.parse(params);
          this.form.demoData = JSON.stringify(obj.demoData);

          this.setting = setting;
        }
      }
    } catch (error) {
      this.$buefy.snackbar.open({
        message: get(error, 'response.data.message', 'An unexpected error occurred, please contact support@enhancify.com'),
        actionText: ' ',
        position: 'is-top',
        indefinite: true,
        type: 'is-danger',
      });
    }

    this.finishLoading();
  },

  methods: {
    ...mapMutations({
      startLoading: MUTATIONS.START_LOADING,
      finishLoading: MUTATIONS.FINISH_LOADING,
    }),
    async applyDemoData() {
      this.startLoading();
      // todo payload to JSON
      const payloadForSetting = new FormData();
      payloadForSetting.set('id', this.setting.paramId);
      payloadForSetting.set('paramName', 'demoData');
      payloadForSetting.set('demoData', this.form.demoData);

      try {
        await updateFlyerTemplateSetting(payloadForSetting);
        this.$buefy.toast.open({
          message: 'Update successful!',
          type: 'is-success',
          duration: 5000,
        });
        this.cancel();
      } catch (error) {
        this.$buefy.snackbar.open({
          message: get(error, 'response.data.message', 'An unexpected error occurred, please contact support@enhancify.com'),
          actionText: ' ',
          position: 'is-top',
          indefinite: true,
          type: 'is-danger',
        });
      }

      this.finishLoading();
    },
    checkAccess(privilege) {
      return this.hasAccess(privilege, privilege, true);
    },
    onCancelClick() {
      this.cancel();
    },
    cancel() {
      this.$emit('cancel');
      this.form.demoData = '';
    },
  },
};
</script>

<style lang="stylus">
.settings .marketing-materials .demo-data
  & .demo-data-buttons
    @media screen and (min-width: 769px)
      margin-top: 35px
    & .button
      min-width: 110px
      height 48px
      text-transform uppercase
</style>
